export default __webpack_public_path__ + "static/media/photo.97be3030.png";